import { useState } from 'react'
import type { AdminDeckDto } from '@lunary/api-client'
import { CardForm } from './card-form'
import type { Selection } from './card-form'
import { CardsPanel } from './cards-panel'
import { CustomSlots } from './custom-cards-panel'
import { ThreeCardForm } from './three-card-form'
import styles from './decks.module.css'

type Props = { deck: AdminDeckDto; uploadsEnabled: boolean }

export function DeckEditor({ deck, uploadsEnabled }: Props) {
  const [selection, setSelection] = useState<Selection | null>(null)
  const daily = deck.kind === 'daily_card'
  const selected = selection?.kind === 'major' ? selection.cardId : null

  return (
    <div className={styles.editorLayout}>
      <div className={styles.main}>
        <CardsPanel
          deck={deck}
          uploadsEnabled={uploadsEnabled}
          selected={selected}
          onSelect={(cardId) => setSelection({ kind: 'major', cardId })}
          extra={daily ? <CustomSlots deck={deck} uploadsEnabled={uploadsEnabled} selection={selection} onSelect={setSelection} /> : undefined}
        />
      </div>
      <aside className={styles.side}>
        {selection ? (
          <div className={styles.sheet}>
            <button type="button" className={`secondary ${styles.sheetClose}`} aria-label="Закрыть редактор карты" onClick={() => setSelection(null)}>
              ×
            </button>
            {daily ? <CardForm deck={deck} selection={selection} onSelect={setSelection} /> : selected && <ThreeCardForm key={selected} deck={deck} cardId={selected} />}
          </div>
        ) : (
          <p className={styles.hint}>
            {daily ? 'Выберите карту в сетке, чтобы увидеть её крупно и поправить описание по умолчанию.' : 'Выберите карту в сетке, чтобы увидеть её крупно и написать описание для «Трёх карт».'}
          </p>
        )}
      </aside>
    </div>
  )
}
